<template>
  <div class="flex justify-center items-center w-full h-screen text-gray-500 text-2xl">
    页面异常,请联系管理员
  </div>
</template>

<script>
export default {

  data() {
    return {}
  },
}
</script>


<style lang="sass" scoped>

</style>